import * as React from 'react';
import { Link } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { styled } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';

export const mainListItems = () => (
  <React.Fragment>
    <ListItemButton component={Link} to="/dashboard">
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Bảng điều khiển" />
    </ListItemButton>
    <ListItemButton component={Link} to="/dashboard/orders">
      <ListItemIcon>
        <ShoppingCartIcon />
      </ListItemIcon>
      <ListItemText primary="Đơn hàng" />
    </ListItemButton>
    <ListItemButton component={Link} to="/dashboard/users">
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Khách hàng" />
    </ListItemButton>
    <ListItemButton component={Link} to="/dashboard/blog">
      <ListItemIcon>
        <CategoryIcon />
      </ListItemIcon>
      <ListItemText primary="Quản lý blogs" />
    </ListItemButton>
    <ListItemButton component={Link} to="/dashboard/products">
      <ListItemIcon>
        <CategoryIcon />
      </ListItemIcon>
      <ListItemText primary="Sản phẩm" />
    </ListItemButton>
  </React.Fragment>
);

const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
  backgroundColor: 'brown',
  color: 'white',
  '&:hover': {
    backgroundColor: 'brown',
  },
}));

export const secondaryListItems = ({ logOut }) => (
  <React.Fragment>
    <CustomListItemButton  onClick={logOut}>
      <ListItemIcon>
      </ListItemIcon>
      <div style={{marginLeft:"18px"}}>
      <ListItemText  primary="Logout" />
      </div>
    </CustomListItemButton >
  </React.Fragment>
);
